import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SimXUser } from '../../../../shared/models/entities/simx-user.model';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { InstitutionAdministrationService } from '../../../institution/services/institution-administration.service';
import { AppNavigationItem } from '../../models/app-navigation-item.model';
import { AppNavigationService } from '../../services/app-navigation.service';
import { CoreService } from '../../services/core.service';

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
})
export class AppSidebarComponent implements OnDestroy, OnInit {
  private readonly _appNavigationService = inject(AppNavigationService);
  private readonly _authenticationService = inject(AuthenticationService);
  private readonly _coreService = inject(CoreService);
  private readonly _institutionAdministrationService = inject(
    InstitutionAdministrationService,
  );
  public router = inject(Router);

  private subscriptions: Subscription = new Subscription();

  appSidebarVisible: boolean = false;

  primaryNavigationItems: Array<AppNavigationItem> = [];
  userNavigationItems: Array<AppNavigationItem> = [];

  authenticatedUser: SimXUser = null;

  appReleaseVersion: string;

  institutionExpirationWindowMax!: number;
  urgentInstitutionExpirationWindowMax!: number;

  constructor() {
    this.institutionExpirationWindowMax =
      this._institutionAdministrationService.institutionExpirationWindowMax;
    this.urgentInstitutionExpirationWindowMax =
      this._institutionAdministrationService.urgentInstitutionExpirationWindowMax;
  }

  ngOnInit(): void {
    this.appReleaseVersion = this._coreService.getAppReleaseVersion();

    this.subscriptions.add(
      this._appNavigationService.showAppSidebar$.subscribe((value: boolean) => {
        this.appSidebarVisible = value;
      }),
    );

    this.subscriptions.add(
      this._appNavigationService.primaryNavigationItems$.subscribe(
        (items: Array<AppNavigationItem>) => {
          this.primaryNavigationItems = items;
        },
      ),
    );

    this.subscriptions.add(
      this._appNavigationService.userNavigationItems$.subscribe(
        (items: Array<AppNavigationItem>) => {
          this.userNavigationItems = items;
        },
      ),
    );

    this.subscriptions.add(
      this._authenticationService.getUser$().subscribe((user: SimXUser) => {
        this.authenticatedUser = user;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
